var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2216_173",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6658 25.1831C8.7362 24.6069 6.9886 23.541 5.59316 22.0891C6.04214 21.5566 6.32202 20.9022 6.39699 20.2097C6.47196 19.5172 6.33861 18.8181 6.01401 18.2019C5.6894 17.5856 5.1883 17.0802 4.57483 16.7503C3.96136 16.4205 3.26343 16.2812 2.57033 16.3502C2.41243 15.5768 2.33309 14.7894 2.3335 14C2.3335 12.7808 2.52016 11.6048 2.86783 10.5H2.91683C3.51169 10.5002 4.09678 10.3487 4.61686 10.06C5.13694 9.77126 5.57484 9.35472 5.88922 8.84973C6.20361 8.34473 6.38409 7.76794 6.41363 7.17382C6.44318 6.57969 6.32081 5.98784 6.05808 5.45415C7.42576 4.18063 9.07978 3.25488 10.8805 2.75507C11.1736 3.33047 11.6201 3.81358 12.1707 4.15095C12.7212 4.48833 13.3544 4.66681 14.0002 4.66665C14.6459 4.66681 15.2791 4.48833 15.8297 4.15095C16.3803 3.81358 16.8268 3.33047 17.1198 2.75507C18.9205 3.25488 20.5746 4.18063 21.9422 5.45415C21.6776 5.99158 21.5553 6.58794 21.5871 7.18616C21.6189 7.78437 21.8038 8.36441 22.1239 8.87075C22.444 9.37709 22.8888 9.79279 23.4155 10.078C23.9423 10.3633 24.5335 10.5086 25.1325 10.5C25.4877 11.6327 25.6679 12.8129 25.6668 14C25.6668 14.805 25.5852 15.5913 25.43 16.3508C24.7369 16.2818 24.039 16.4211 23.4255 16.7509C22.812 17.0808 22.3109 17.5862 21.9863 18.2024C21.6617 18.8187 21.5284 19.5178 21.6033 20.2103C21.6783 20.9028 21.9582 21.5571 22.4072 22.0896C21.0117 23.5414 19.2641 24.6071 17.3345 25.1831C17.1079 24.4768 16.6629 23.8608 16.0637 23.4237C15.4644 22.9866 14.7419 22.7511 14.0002 22.7511C13.2585 22.7511 12.5359 22.9866 11.9367 23.4237C11.3374 23.8608 10.8924 24.4768 10.6658 25.1831Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 18.0833C14.5366 18.0833 15.0675 17.9777 15.5629 17.7725C16.0584 17.5673 16.5085 17.2665 16.8877 16.8873C17.2669 16.5081 17.5676 16.058 17.7728 15.5626C17.978 15.0672 18.0837 14.5362 18.0837 14C18.0837 13.4637 17.978 12.9327 17.7728 12.4373C17.5676 11.9419 17.2669 11.4918 16.8877 11.1126C16.5085 10.7334 16.0584 10.4327 15.5629 10.2275C15.0675 10.0222 14.5366 9.91663 14.0003 9.91663C12.9174 9.91663 11.8787 10.3468 11.113 11.1126C10.3472 11.8784 9.91699 12.917 9.91699 14C9.91699 15.0829 10.3472 16.1215 11.113 16.8873C11.8787 17.6531 12.9174 18.0833 14.0003 18.0833Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2216_173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "#5B58E6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e758490e7ae9430c6862ef673bfccdb4.svg";
export { ForwardRef as ReactComponent };